import React, { Component } from "react";
import ApiConnect from "../../../Utils/ApiConnect";
import ReactDatatable from "@ashvin27/react-datatable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import QuickView from "../../Components/QuickView";
class Transaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewData: [],
      loading: true,
      startDate: new Date(),
      endDate: new Date(),
      showModal: false,
      PreviewID: false,
    };
    this.columns = [
      {
        key: "date",
        text: "Order Date",
        sortable: true,
      },
      {
        key: "table_date",
        text: "Table Date",
        sortable: true,
      },
      {
        key: "id",
        text: "Order Id",
        sortable: true,
        cell: (record) => {
          return (
            <React.Fragment>
              {" "}
              <a
                onClick={() => {
                  this.setState({
                    showModal: true,
                    PreviewID: record.id,
                  });
                }}
                href="#_"
              >
                {record.id}
              </a>
              {record.membership !== "0" ? (
                <span className="material-icons-outlined text-success">
                  contact_mail
                </span>
              ) : (
                ""
              )}
              {record.promo !== "0" ? (
                <span className="material-icons-outlined text-success">
                  local_activity
                </span>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        },
      },
      {
        key: "table",
        text: "Table",
        sortable: true,
      },
      {
        key: "discount",
        text: "Discount",
        sortable: true,
      },
      {
        key: "total",
        text: "Amount",
        sortable: true,
      },
      {
        key: "items",
        text: "Items",
        sortable: true,
      },
      {
        key: "payment_type",
        text: "Payment",
        sortable: true,
      },
      {
        key: "waiter",
        text: "Waiter/Users",
        sortable: true,
        cell: (record) => {
          return (
            <React.Fragment>
              <div className="avatar-list avatar-list-overlap">
                <a className="avatar" href="#_">
                  <img src={record.waiter.avatar} alt={record.waiter.name} />
                </a>
                <a className="avatar" href="#_">
                  <img src={record.cashier.avatar} alt={record.cashier.name} />
                </a>
              </div>
              <button
                className="table-action btn btn-square btn-pure hover-warning"
                onClick={() => {
                  this.setState({
                    showModal: true,
                    PreviewID: record.id,
                  });
                }}
              >
                <span className="material-icons-outlined">visibility</span>
              </button>
            </React.Fragment>
          );
        },
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 30,
      length_menu: [30, 60, 90],
      show_filter: true,
      show_pagination: true,
      button: {
        excel: false,
        print: false,
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  GetTransactionData() {
    ApiConnect.get(
      `/POS/Report/Transaction?from=${format(
        this.state.startDate,
        "yyyy-MM-dd"
      )}&to=${format(this.state.endDate, "yyyy-MM-dd")}`
    )
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({ viewData: response.data.data, loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  SetshowQuick = () => {
    this.setState({ showModal: false });
  };
  render() {
    return (
      <div className="card">
        <div className="card-header pl-3 pr-3">
          <h4>Transaction</h4>
          <div className="input-group">
            <label htmlFor="start">From Date</label>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              className="form-control"
              maxDate={new Date()}
              closeOnScroll={true}
              selected={this.state.startDate}
              value={this.state.startDate}
              onChange={(e) => this.setState({ startDate: e })}
              placeholderText="Start Date"
            />
          </div>
          <div className="input-group">
            <label htmlFor="start">To Date</label>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              className="form-control"
              maxDate={new Date()}
              closeOnScroll={true}
              selected={this.state.endDate}
              value={this.state.endDate}
              onChange={(e) => this.setState({ endDate: e })}
              placeholderText="End Date"
            />
          </div>
          <button
            className="btn btn-info"
            onClick={(e) => this.GetTransactionData()}
          >
            Fetch
          </button>
        </div>
        <div className="card-body pl-3 pr-3">
          <ReactDatatable
            className="table"
            config={this.config}
            records={this.state.viewData}
            columns={this.columns}
            loading={this.state.loading}
          />
          <hr className="hr-sm w-100 mr-0" />
          <table className="table table-borderless text-center">
            <tbody>
              <tr className="d-flex col-12">
                <td className="col">Cash</td>
                <td className="col text-right">
                  {" "}
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                        (sum +=
                          i.payment_type === "Cash" ? parseFloat(i.total) : 0),
                      0
                    )
                  )}
                </td>
                <td className="col text-right">Card</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                        (sum +=
                          i.payment_type === "Card" ? parseFloat(i.total) : 0),
                      0
                    )
                  )}
                </td>
              </tr>

              <tr className="d-flex col-12">
                <td className="col">Fonepay/QR Payment</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                        (sum +=
                          i.payment_type === "Fonepay"
                            ? parseFloat(i.total)
                            : 0),
                      0
                    )
                  )}
                </td>
                <td className="col text-right">Account</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                        (sum +=
                          i.discount === "Account" ? parseFloat(i.total) : 0),
                      0
                    )
                  )}
                </td>
              </tr>
              <tr className="d-flex col-12">
                <td className="col">Discount</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                        (sum += i.discount ? parseFloat(i.discount) : 0),
                      0
                    )
                  )}
                </td>
                <td className="col text-right">Promo Code</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                        (sum +=
                          i.payment_type === "Account"
                            ? parseFloat(i.total)
                            : 0),
                      0
                    )
                  )}
                </td>
              </tr>
              <tr className="d-flex col-12">
                <td className="col">Membership</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                        (sum += i.discount ? parseFloat(i.discount) : 0),
                      0
                    )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          <QuickView
            trigger={this.state.showModal}
            type="Sales Entry"
            id={this.state.PreviewID}
            hideTrigger={this.SetshowQuick}
          />
        </div>
      </div>
    );
  }
}
export default Transaction;
